import { render, staticRenderFns } from "./Save-popin.vue?vue&type=template&id=c7bbeee8&scoped=true&"
import script from "./Save-popin.vue?vue&type=script&lang=js&"
export * from "./Save-popin.vue?vue&type=script&lang=js&"
import style0 from "./Save-popin.vue?vue&type=style&index=0&id=c7bbeee8&prod&scoped=true&lang=scss&"
import style1 from "./Save-popin.vue?vue&type=style&index=1&id=c7bbeee8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bbeee8",
  null
  
)

export default component.exports